// Is a job SERVED (as opposed to only attempted)? CommonJS, no destructuring.
const SERVED_OUTCOMES = ["personal_service", "substituted_service"];

function servedAttempt(job) {
  const list = (job && job.serviceAttempts) || [];
  for (let i = 0; i < list.length; i += 1) {
    if (/^served_/.test(String((list[i] && list[i].outcome) || ""))) return list[i];
  }
  return null;
}

function isServed(job) {
  if (!job) return false;
  const targets = job.serviceTargets || [];
  for (let i = 0; i < targets.length; i += 1) {
    if (SERVED_OUTCOMES.includes(String((targets[i] && targets[i].legal_service_outcome) || ""))) return true;
  }
  return !!servedAttempt(job);
}

// The outcome dropdown, split so "served" can never be mistaken for an attempt.
function outcomeGroups(outcomes) {
  const all = outcomes || [];
  return {
    served: all.filter(function (o) { return /^served_/.test(o.value); }),
    attempt: all.filter(function (o) { return !/^served_/.test(o.value); }),
  };
}

const isServedOutcome = (v) => /^served_/.test(String(v || ""));

// Three or more unsuccessful attempts and no service yet (for this service job
// when one is named): time for a Declaration of Due Diligence.
const DILIGENCE_ATTEMPTS = 3;
function diligenceDue(attempts, targetId) {
  const list = (attempts || []).filter(function (a) { return a && (!targetId || !a.target_id || a.target_id === targetId); });
  if (list.some(function (a) { return isServedOutcome(a.outcome); })) return false;
  return list.length >= DILIGENCE_ATTEMPTS;
}

module.exports = {
  DILIGENCE_ATTEMPTS, diligenceDue, SERVED_OUTCOMES, servedAttempt, isServed, outcomeGroups, isServedOutcome };
